<template>
  <div class="panel panel-gray wraper">
    <div class="panel-header compact" id="list-header">
      <template v-if="instrumentId">
        <div>
          <unit-path :id="instrumentId" :lastHasLink="true"></unit-path>
        </div>
      </template>
      <template v-else>
        <q-btn-toggle
            v-model="filter"
            color="white"
            no-caps
            :dense="$route.name!=='cases'"
            text-color="primary"
            toggle-color="primary"
            :options="[
              {label: 'Все', value: 'all'},
              {icon: 'build', value: 'active'},
              {icon: 'done_all', value: 'completed'},
              {icon: 'hourglass_empty', value: 'pending'},
              {icon: 'pan_tool', value: 'canceled'}
            ]"
        />
        <q-checkbox v-if="isEngineer" v-model="my" label="Только мои" />
      </template>
    </div>
    <div class="panel-group" :class="{scroll: $route.meta.showLeft}">
        <case-item
            :item="item"
            :needPath="!instrumentId"
            :key="item._id"
            :class="{selected: ind === activeIndex}"
            v-for="(item, ind) in visibleCases"
        />
      <my-scroll :handler="getMore" ref="myscroll">
        <q-spinner-dots :size="40" />
      </my-scroll>
      <q-btn
          v-back-to-top.animate="500"
          round
          color="teal-5"
          class="fixed-bottom-left"
          style="margin: 0 0 15px 15px"
      >
        <q-icon name="keyboard_arrow_up" />
      </q-btn>
    </div>
  </div>
</template>
<style scoped lang="stylus">
  @import '~variables'
  .q-checkbox
    margin-left 20px
  #list-header
    justify-content flex-start
    color $primary
    .q-btn-group
      box-shadow none
</style>
<script>
import CaseItem from 'components/case-item.vue';
import UnitPath from 'components/unit-path.vue';
import MyScroll from 'components/my-scroll.vue';

const statusLabel = {
  active: 'В работе',
  pending: 'Отложенные',
  completed: 'Выполненные',
  canceled: 'Отмененные',
  all: 'Все',
};
export default {
  name: 'caselist',
  components: {
    CaseItem,
    UnitPath,
    MyScroll,
  },
  data() {
    return {
      limit: 10,
      instrumentId: this.$route.params.iid,
      my: false, // only my cases
    };
  },
  watch: {
    filter: {
      immediate: true,
      handler: 'handle',
    },
    my: {
      handler: 'handle',
    },
  },
  mounted() {
    this.$watch(
      'activeIndex',
      function (i) {
        this.$store.commit('setActive', i);
        this.$store.commit('setNext', (i < (this.cases.length - 1)) && (i > -1) ? this.cases[i + 1]._id : null);
        this.$store.commit('setPrev', i > 0 ? this.cases[i - 1]._id : null);
        if (this.limit < (i + 1)) this.limit = i + 1;
        setTimeout(() => {
          if (this.visibleCases[i]) {
            const id = this.visibleCases[i]._id;
            if (document.getElementById(id)) {
              document.getElementById(id).scrollIntoViewIfNeeded();
            }
          }
        }, 500);
      },
      { immediate: true },
    );
  },
  computed: {
    activeIndex() {
      return this.cases.findIndex(c => c._id === this.$route.params.id);
    },
    filter: {
      get() {
        return this.$route.params.filter;
      },
      set(v) {
        this.$router.push(`/c/${v}`);
      },
    },
    isEngineer() {
      return this.$store.getters.isEngineer;
    },
    cases() {
      if (this.instrumentId) {
        return this.$store.getters.subTree(this.instrumentId);
      }
      const statusMap = {
        active: 1,
        pending: 2,
        completed: 3,
        canceled: 4,
        all: 1000,
      };
      let cases;
      if (this.filter === 'all') {
        if (this.my) {
          cases = this.$utils.ov2a(this.$store.state.cases)
            .filter(c => c.master === this.$store.state.user.roles[0]);
        } else {
          cases = this.$utils.ov2a(this.$store.state.cases);
        }
      } else {
        const filterFN = (f, m) => (c) => {
          if (m) {
            return (c.master === this.$store.state.user.roles[0]) && (c.status === statusMap[f]);
          }
          return c.status === statusMap[f];
        };
        cases = this.$utils.ov2a(this.$store.state.cases).filter(filterFN(this.filter, this.my));
      }
      return cases.sort((a, b) => {
        if (a.status === b.status) {
          if (a.status === statusMap.active) {
            return a.workDate - b.workDate;
          } else if (a.status === statusMap.completed) {
            return b.workDate - a.workDate;
          }
          return a.requestId - b.requestId;
        }
        return a.status - b.status;
      });
    },
    visibleCases() {
      return this.cases.slice(0, this.limit);
    },
  },

  methods: {
    handle() {
      if (this.filter) {
        if (statusLabel[this.filter]) {
          document.title = `Кейсы - ${statusLabel[this.filter]}`;
        } else {
          this.$router.push('/c/all');
        }
      }
      this.limit = 10;
      this.$store.commit('setTotal', this.cases.length);
      if (this.$refs.myscroll) this.$refs.myscroll.init();
    },
    getMore() {
      if (this.limit < this.cases.length) {
        this.limit = Math.min(this.limit + 10, this.cases.length);
        return Promise.resolve(true);
      }
      return Promise.resolve(false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/cases-list.vue